import { useState } from 'react';
import { InvoiceTypeClient, InvoiceTypeDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useInvoiceTypeApi = () => {
    const apiClient = new InvoiceTypeClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: InvoiceTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createInvoiceType(data);
        } catch (err: any) {
            setError(err.message || 'Error creating InvoiceType');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: InvoiceTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateInvoiceType(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating InvoiceType');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getInvoiceTypeById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching InvoiceType');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchInvoiceTypes(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching InvoiceTypes');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteInvoiceType(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting InvoiceType');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};